import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Segment layout: carries the "Applications" breadcrumb for the list and every detail page. */
export const Route = createFileRoute('/_authed/applications')({
  staticData: { crumbKey: 'nav.applications' },
  component: Outlet,
});
